(function(){
  var locale = EDITOR_LOCALE;

  window.I18n = {
    locale: locale,
    translations: require('./pegasus/locales/' + locale + '.yml')[locale]
  };

  Em.I18n.translations = window.I18n.translations;

  window.documentURL = [
    '/pegasus_document/assets/pegasus_document',
    EDITOR_DOC_TYPE,
    EDITOR_LOCALE
  ].join('-').concat('.html').concat('?' + Math.random()*10000000000000000);

  window.vr_template = function(){
    return Pegasus.get('options.template') || require("./pegasus/" + EDITOR_DOC_TYPE + ".jst.ejs")();
  };
})();
